
import { defineComponent } from 'vue';
import { DateTime } from 'luxon';

import { created_date as dateGenerated } from '@/data/created_date.json';
import Question from '@/assets/img/question-icon.svg';

export default defineComponent({
    name: 'Header',
    components: {},
    setup() {
        return {
            dateGenerated: DateTime.fromISO(dateGenerated)
                .toLocaleString(DateTime.DATE_MED),
            Question
        };
    }
});
